import { useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import ConnectOptin from "components/ConnectOptin/ConnectOptin";
import InsButton from "components/InsButton/InsButton";

const Consent = ({ t, onValidate }) => {

    const [optins, setOptins] = useState([]);
    const [newsletter, setNewsletter] = useState(false);
    const [validConsent, setValidConsent] = useState(false);

    const createAccount = () => {
        let obj = {
            opt_ins: {
                custom: {},
            },
            newsletter,
        };
        optins.forEach((el) => {
            if (el.id !== "gdpr") {
                if (el.id !== "newsletter") {
                    obj.opt_ins["custom"][el.id] = el.value;
                } else {
                    obj.opt_ins[el.id] = el.value;
                }
            }
        });
        onValidate(obj);
    };

    return (
        <div className="max-w">
            <div className="sso-optin-container">
                <ConnectOptin
                    optins={optins}
                    updateOptins={setOptins}
                    updateNewsletter={setNewsletter}
                    updateValidConsent={setValidConsent}
                    required={true}
                />
                <div className="bottom-container">
                    {!validConsent && (
                        <div className="alert_msg mb10">{t("required_only")}</div>
                    )}
                    <InsButton
                        text={t("create_account")}
                        onClick={createAccount}
                        disabled={!validConsent}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    config: state.config,
});

export default connect(mapStateToProps)(withTranslation()(Consent));
